import { makeid } from 'utils/helpers/makeid';

import {
  additionalFollowUpItem,
  freeTextCommentsItem,
  isPatientCROorDNCItem,
  needEscalateItem,
  twoWaySyncInfoItem,
  uniqueDaysItem,
} from '../common';

import type { TFormItem } from '../../types';

export const bloodPressure: TFormItem[] = [
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average systolic blood pressure this week?{' '}
        <span>__ mmHg</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'systolicAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'systolicAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'systolicAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average diastolic blood pressure this week?{' '}
        <span>__ mmHg</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'diastolicAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'diastolicAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'diastolicAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average pulse this week? <span>__ bpm</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'pulseAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'pulseAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'pulseAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Were all BP and pulse readings this week within the target range for
        this patient?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'bpAndPulseWithinRange',
    options: [
      { label: 'Yes', value: true, key: makeid(10) },
      { label: 'No', value: false, key: makeid(10) },
    ],
    items: [
      {
        type: 'textarea',
        name: 'bpAndPulseWithinRangeComment',
        title: null,
        key: makeid(10),
      },
    ],
  },
  { ...uniqueDaysItem('blood pressure') },
  { ...twoWaySyncInfoItem },
  { ...isPatientCROorDNCItem },
  { ...additionalFollowUpItem },
  { ...needEscalateItem },
  { ...freeTextCommentsItem },
];
